export type PickupQueueOrder = {
  orderType: string
  orderStatus: string
  paymentStatus: string
  queueNumber?: number | null
  location: { startTime: string }
}

const THAI_UTC_OFFSET_MS = 7 * 60 * 60 * 1000 // ไทยไม่มี DST — offset คงที่ (เหมือน getThaiDateKey ฝั่ง service)

// 'YYYY-MM-DD' ตามปฏิทินไทย — เทียบเป็น string ได้ตรงลำดับเวลา
const thaiDateKey = (ms: number): string => new Date(ms + THAI_UTC_OFFSET_MS).toISOString().slice(0, 10)

/**
 * ป้ายเลขคิวบนการ์ดออเดอร์หน้า /history — ให้ลูกค้า pickup ออนไลน์บอกพนักงานที่เคาน์เตอร์ได้
 * (สลิปออนไลน์ของพนักงานพิมพ์ P{n} ตัวใหญ่ — เลขคิวแยกตามประเภท R/P/D ตั้งแต่ 2026-09-19,
 *  ตารางเดียวกับ remedy-service src/services/order/queueNumbering.js)
 *
 * แสดงเฉพาะ pickup ที่จ่ายแล้ว และยังรอ (queue) หรือพร้อมรับ (done — ระบบไม่มีสถานะ "รับแล้ว")
 * ยังไม่จ่าย = ซ่อน: เลขออกตั้งแต่สร้างออเดอร์ ถ้าไม่จ่าย เลขนั้นร้านไม่มีสลิป
 * วันนัดรับก่อนวันนี้ (ไทย) = ซ่อน: เลขคิว reset ทุกวัน ป้ายเก่าเป็นแค่สิ่งรบกวนและอ่านผิดใบได้
 * — ออเดอร์สั่งล่วงหน้านัดรับวันหลังยังแสดง (สลิปวันนั้นพิมพ์เลขเดียวกัน)
 *
 * ห้ามเอาเลขนี้ไปลิงก์ /q/:n — จอคิวสาธารณะนับเฉพาะบิลหน้าร้าน เลขออนไลน์จะขึ้น Ready ผิด
 */
export const getPickupQueueLabel = (order: PickupQueueOrder, now: Date): string | null => {
  const { orderType, orderStatus, paymentStatus, queueNumber, location } = order
  if (orderType !== 'pickup') return null
  if (paymentStatus !== 'success') return null
  if (orderStatus !== 'queue' && orderStatus !== 'done') return null
  if (typeof queueNumber !== 'number' || !Number.isInteger(queueNumber) || queueNumber < 1) {
    return null
  }
  const pickupMs = new Date(location.startTime).getTime()
  if (Number.isNaN(pickupMs)) return null
  if (thaiDateKey(pickupMs) < thaiDateKey(now.getTime())) return null
  return `P${queueNumber}`
}
